import { render, staticRenderFns } from "./payroll_report.vue?vue&type=template&id=5a116e3a&scoped=true&"
import script from "./payroll_report.vue?vue&type=script&lang=js&"
export * from "./payroll_report.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a116e3a",
  null
  
)

export default component.exports